<template>
  <v-form @submit.prevent="save">
    <span class="text-subtitle-1">LeoRad</span>
    <v-switch
      v-model="form.enable"
      label="Ativo"
      color="primary"
      class="mt-0 mb-2"
    ></v-switch>
    <v-switch
      v-model="form.auto"
      label="Executa ao criar novo laudo"
      color="primary"
      class="mt-0 mb-2"
    ></v-switch>
    <v-text-field
      v-model="form.token"
      label="Token"
      required
      dense
      outlined
    ></v-text-field>
  </v-form>
</template>
<script>
import Api from '@/resources/NajaSocialApi'
import Setting from '@/helpers/setting'
export default {
  name: 'LeoRadForm',
  data: () => ({
    loading: false,
    user: {
      name: null,
      id: null,
      user_id: null,
    },
    form: {
      enable: false,
      user: null,
      password: null,
    },
  }),
  methods: {
    clearForm() {
      this.loading = false
      this.user = {
        id: null,
        name: null,
        user_id: null,
      }
      this.form = {
        enable: false,
        user: null,
        password: null,
      }
    },

    setForm(user, data) {
      this.user = user
      this.form = {
        ...this.form,
        ...data,
      }
    },

    save() {
      this.loading = true
      const data = {
        user: {
          credentials_for_leorad: Setting.reverse(this.form),
        },
      }

      console.log('data', data)

      Api.users
        .save(this.user.user_id, data)
        .then(() => {
          this.$root.$children[0].toast('Configuração salva com sucesso')
        })
        .catch(error => {
          if (error.response) {
            this.$root.$children[0].toast('Erro ao salvar configuração')
          } else {
            throw error
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
